import React, {useEffect} from 'react';
import * as css from './css/goods-list';
import showPrice from 'utils/ShowPrice';
import useMyStores from "@/hooks/useMyStores";
import {observer} from "mobx-react";

const GoodsList = (props) => {

    const {className} = props;

    const {goodsList: store, app} = useMyStores()

    useEffect(() => {
        app.fetchContact()
    }, []);

    const renderSpecification = specificationMap => {
        let dom = [];
        for (const [key, value] of specificationMap) {
            dom.push(
                <div className='specification' key={value}>
                    {key}：{value}
                </div>
            );
        }

        return dom;
    };

    const renderGoods = goodsList => {
        return goodsList.map(goods => {
            const {
                id,
                name,
                currentPrice,
                originPrice,
                count,
                img,
                specificationMap
            } = goods;

            return (
                <css.Goods key={id}>
                    <div className='img-block'>
                        <div className='img-wrapper'>
                            <img src={img} alt='' className='img'/>
                        </div>
                    </div>
                    <div className='info-block'>
                        <div className='goods-name'>{name}</div>
                        <div className='current-price-floor'>
                            <div className='current-price'>{showPrice(currentPrice)}</div>
                            <div className='count'>x{count}</div>
                        </div>
                        <div className='origin-price-floor'>{showPrice(originPrice)}</div>
                        <div className='specification-floor'>
                            {renderSpecification(specificationMap)}
                        </div>
                    </div>
                </css.Goods>
            );
        });
    };

    return (
        <css.GoodsList className={className}>
            <div className='bg'/>
            <button
                className='close-button'
                onClick={() => {
                    store.show = false;
                }}
            />
            <img src={require('./img/title.png')} alt='' className='title'/>
            <img
                src={require('./img/title-bottom.png')}
                alt=''
                className='title-bottom'
            />
            <css.Container>{renderGoods(store.goodsList)}</css.Container>

            <div className='shop-block'>
                <div className='shop-name-block'>
                    联系店家（{app.concat && app.concat.name}）完成购买
                    <div className='bg'/>
                </div>
                <div className='phone-block'>
                    {app.concat && app.concat.phone}
                    <div className='bg'/>
                </div>
            </div>
        </css.GoodsList>
    );
}

export default observer(GoodsList);
